import axios from 'axios';
import React, { useEffect, useState } from 'react'
import DataTable from "react-data-table-component";
import { ENDPOINTS } from '../../../../js/api/_config';
import { customStyles } from "../../../common/styling/constants";
import ColorCount from "../../color-count";
import { convertTimeToLocation, convertDateLastContracted } from "../../../common/constant/constant";


const BulkUploadHistory = ({ toggleDetails, BulkFileDetails }) => {


    const [bulkHistory, setBulkHistory] = useState({
        filter: '',
        columns: '',
        sorts: '',
        data: [],
        totalCount: 0,
        currentPage: -1,
        rowsPerPage: 10,
    });

    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () => {
        try {

            setIsLoading(true);
            let queryParams = {
                pages: 1,
                PageSize: 1000,
                Sorts: '-createdAt'
            };

            await axios.get(ENDPOINTS.PATIENT.BULK_UPLOAD_LOGS, { params: queryParams }).then(res => {
                setBulkHistory({
                    ...bulkHistory,
                    data: res.data.data.items
                });
            }).catch((error) => {
            })
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [])


 const Columns = [
  {
    name: "Uploaded By",
    selector: (row) => (
      <div className="flex items-center">
        <span className="recruiter-intials">
          {row.uploadedBy && row.uploadedBy?.charAt(0).toUpperCase()}
          {row.uploadedBy &&
            row.uploadedBy?.split(" ")[1]?.charAt(0).toUpperCase()}
        </span>
        <span className="pl-1 block truncate font-mont text-[14px] font-[600]">
          {row.uploadedBy}
        </span>
      </div>
    ),
    //width: "15%", // ✅ 15% of table width
  },
  {
    name: "File Name",
    selector: (row) => (
      <span
        onClick={() => BulkFileDetails(row)}
        className="text-blue-500 hover:text-blue-700 hover:underline p-2 block truncate"
      >
        {row.bulkUploadFileName}
      </span>
    ),
    //maxWidth: "30%", // ✅ takes 30% of table width
  },
  {
    name: "Study",
    selector: (row) => (
      <div className="truncate">{row.trialName}</div>
    ),
    width: "20%", // ✅ takes 20%
  },
  {
    name: "Uploaded On",
    selector: (row) =>
      convertDateLastContracted(convertTimeToLocation(row.createdAt)),
    width: "15%", // ✅ 10%
  },
  {
    name: "Successful",
    selector: (row) => <ColorCount color="#66D062" count={row.successCount} />,
    width: "8%",
  },
  {
    name: "Queued",
    selector: (row) => <ColorCount color="#536493" count={row.queuedCount} />,
    width: "8%",
  },
  {
    name: "Skipped",
    selector: (row) => <ColorCount color="#B91C1C" count={row.skippedCount} />,
    width: "9%", // adjust so total ≈ 100%
  },
];



    return (
        <>
            {isLoading ? (<div class="mt-[100px] spinnerwrapper !h-auto"><div class="spinner"></div></div>) : (
                <>
                    <div className="min-w-[860px]">
                        <DataTable
                            //fixedHeader
                            //fixedHeaderScrollHeight="calc(100vh - 250px)"
                            columns={Columns}
                            data={bulkHistory.data || []}
                            customStyles={customStyles}
                        />
                    </div>
                </>
            )}
        </>
    )
}

export default BulkUploadHistory